import { formatNumericBody } from '@nsftx/seven-client-retail-utils'
import {
  getConfiguredCurrencySymbol,
  getNumberFormat
} from '#src/services/retailSdkService'

export type NumberFormatStyle = 'decimal' | 'currency' | 'percent'

export type FormatNumberOptions = {
  style?: NumberFormatStyle
  currencySymbol?: string
}

export const formatNumber = (value: number | string, options?: FormatNumberOptions): string => {
  const style = options?.style ?? 'decimal'
  const body = formatNumericBody(value, getNumberFormat())

  if (style === 'percent') {
    return `${body}%`
  }

  if (style === 'currency') {
    const symbol = options?.currencySymbol ?? getConfiguredCurrencySymbol()
    if (symbol) {
      return `${body} ${symbol}`
    }
  }

  return body
}
